<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Ajout d'une image</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-4">
            <form style="padding-left: 10px">
                <div class="form-group">
                    <div class="input-group align-items">
                        <label class="label-zones">Titre</label>
                        <input class="form-control mr-1 zone-input" name="title" [(ngModel)]="photo.title">
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group align-items">
                        <label class="label-zones">Catégorie</label>
                        <input class="form-control mr-1 zone-input" name="category" [(ngModel)]="photo.category">
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group align-items">
                        <label class="label-zones">Photo</label>
                        <input type="file" class="zone-input" (change)="handleFileInput($event.target.files)">"
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(this.photo)">Enregistrer</button>
</div>
